import { render, staticRenderFns } from "./StagingEditorCitationsTab_CitationCard.vue?vue&type=template&id=4b860a05"
import script from "./StagingEditorCitationsTab_CitationCard.vue?vue&type=script&lang=ts"
export * from "./StagingEditorCitationsTab_CitationCard.vue?vue&type=script&lang=ts"
import style0 from "./StagingEditorCitationsTab_CitationCard.vue?vue&type=style&index=0&id=4b860a05&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports